import Vue from 'vue'
import VueAMap from 'vue-amap' // 高德地图
// import website from '@/config/website'
import store from '@/store'
import { getGDKey } from '@/api'
import { RSAdecrypt } from '@/util'

Vue.use(VueAMap)

async function getKey() {
  const data = {
    token: store.state.user.token,
    platform: 'pc'
  }
  const res = await getGDKey(data)
  if (res.code === 0) {
    return JSON.parse(RSAdecrypt(res.data))
  }
}

export const initMap = async () => {
  const res = await getKey()
  console.log('jsapi', res)
  // 高德地图初始化配置
  VueAMap.initAMapApiLoader({
    // key: website.amapKey,
    key: res.jsapi,
    plugin: [
      'AMap.Geocoder',
      'AMap.Geolocation',
      'AMap.Autocomplete',
      'AMap.PlaceSearch',
      'AMap.Scale',
      'AMap.OverView',
      'AMap.ToolBar',
      'AMap.MapType',
      'AMap.PolyEditor',
      'AMap.CircleEditor',
      'AMap.AMapUI',
      'AMap.PolygonEditor',
      'AMap.DistrictSearch',
      'AMap.DragRoute',
      'AMap.Driving'
    ],
    v: '1.4.15'
  })
}
